import React from 'react';

type InlineFunctional<Props> = React.FC<Props>;

export default function createSvg<AdditionalProps extends object = {}>(
  component: InlineFunctional<React.SVGProps<SVGSVGElement> & AdditionalProps>,
) {
  return component;
}
